<template>
  <div class="auth-wrapper auth-v2 container">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <!-- <h2 class="brand-text text-primary ml-1">
          Vuexy
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
          width="500px"
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="5"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >

          <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
            <b-img
            width="170px"
              fluid
              :src="imgUrl1"
              alt="Login V2"
            />
          </div>
          <b-card-title
            class="mb-1 mt-4 font-weight-bold"
            title-tag="h2"
          >
            Welcome to My PODA 👋
          </b-card-title>
          <b-card-text class="mb-5">
            Please sign-in to your account.
          </b-card-text>
   <b-alert
   v-if="error"
        variant="danger"
        show
      >
        <h4 class="alert-heading">
          Error
        </h4>
        <div class="alert-body">
          <span>{{ error }}</span>
        </div>
      </b-alert>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="Enter Your Username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link style="color:black !important" :to="{name:'auth-forgot-password'}">
                    <small class="font-weight-bold">Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- :to="{name:dashboard-ecommerce}" -->
              <!-- submit buttons -->
              <b-button
                type="submit"
                style="background-color:black !important"
                block
                :disabled="invalid || isLoading"
                >
                <span v-if="isLoading">
                  <b-spinner small class="mr-50" />
                  Logging In...
                </span>
                <span v-else>
                  Log In
                </span>
              </b-button>

              <div class="text-center mt-1 auth-footer-text login-register-text">
                <span>Register Your Company?</span>
                <b-link :to="{ name: 'auth-register' }">
                  Register
                </b-link>
              </div>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">

            <span>New on our platform? </span>
            <b-link :to="{name:'auth-register'}">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              variant="github"
              href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { setupVendorWebPush } from '@/plugins/webPush'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import imgUrl from '../../../assets/images/svg/login-illustration.svg';
import imgUrl1 from '../../../../public/logo.png';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',imgUrl,imgUrl1,
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      error:'',
      isLoading: false,
      // validation rules
      required,
      email,
    }
  },
  mounted() {
    clearInterval(this.$store.state.app.masterInterval)
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    // imgUrl() {
    //   if (store.state.appConfig.layout.skin === 'dark') {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
    //     return this.sideImg
    //   }
    //   return this.sideImg
    // },
  },
  methods: {
    async login() {
      this.error = ''
      const success = await this.$refs.loginForm.validate()

      if (!success || this.isLoading) {
        if (!success) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Invalid Username and Password',
              icon: 'XIcon',
              variant: 'danger',
              text: 'Enter Right Username & Password and Try Again',
            },
          })
        }
        return
      }

      this.isLoading = true
      try {
        const res = await useJwt.login({
          email: this.userEmail,
          password: this.password,
        })

        if (res.data && res.data.success && res.data.data) {
          const { user, access_token: accessToken, refresh_token: refreshToken } = res.data.data
          const role = String(user?.role || '').toLowerCase()
          if (!['advertiser', 'vendor'].includes(role)) {
            this.error = 'This account is not a vendor advertiser. Sign in with a vendor account, or register as a vendor first.'
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Vendor account required',
                icon: 'XIcon',
                variant: 'danger',
                text: this.error,
              },
            })
            return
          }
          const userData = {
            ...user,
            email: user.email,
            name: user.name,
            role: user.role,
            token: accessToken,
          }
          useJwt.setToken(accessToken)
          useJwt.setRefreshToken(refreshToken)
          localStorage.setItem('userData', JSON.stringify(userData))
          localStorage.setItem('accessToken', accessToken)
          this.$ability.update({
            action: 'manage',
            subject: 'all',
          })
          setupVendorWebPush()
          await this.$router.push('/')
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Welcome ${user.name || user.email}`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'You have successfully signed in to the vendor panel.',
            },
          })
        } else {
          this.error = res.data?.message || 'Invalid email or password'
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Invalid Username and Password',
              icon: 'XIcon',
              variant: 'danger',
              text: 'Enter Right Username & Password and Try Again',
            },
          })
        }
      } catch (error) {
        this.error = error.response?.data?.message || 'Login failed'
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Login Failed',
            icon: 'XIcon',
            variant: 'danger',
            text: this.error,
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
